import { render } from "./ReceiptComponent.vue?vue&type=template&id=22bc9053&ts=true"
import script from "./ReceiptComponent?vue&type=script&lang=ts"
export * from "./ReceiptComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__